<template>
	<div class="app-body">
		<div class="a-flex-rsbc a-ptb-6">
			<bread-crumb></bread-crumb>
		</div>

		<el-card class="el-main">
			<el-table :data="tableData" :highlight-current-row="true" ref="demandCooperationList" v-sticky="{ top: 0, parent:'.el-card__body' }">
                <!-- 合作意向描述 -->
                <el-table-column prop="content" label="合作意向描述" width="200" >
                    <template slot-scope="{ row }">
                        <div class="a-flex-rfsc">
                            <span style="width: 140px;" class="textOver1">{{ row.content }}</span>
                            <el-tooltip placement="top">
                                <div slot="content" style="width: 300px;">{{ row.content }}</div>
                                <el-button type="text">查看</el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>

                <!-- 图片附件 -->
                <el-table-column prop="attachmentUrls" label="图片附件" min-width="140">
                    <template slot-scope="{ row }">
                        <div v-if="row.attachmentUrls && getImageList(row.attachmentUrls).length > 0" class="image-attachment a-flex-rfsc">
                            <el-image 
                                :src="getImageList(row.attachmentUrls)[0]" 
                                :preview-src-list="getImageList(row.attachmentUrls)"
                                fit="cover"
                                style="width: 80px; height: 80px;border-radius: 6px">
                            </el-image>
                            <span class="image-count a-ml-10">{{ getImageCount(row.attachmentUrls) }}张</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 意向人名称 -->
                <el-table-column prop="intentUserName" label="意向人名称" min-width="180" >
                    <template slot-scope="{ row }">
                        <span>{{ row.intentUserName }}</span>
                    </template>
                </el-table-column>

                <!-- 意向人联系电话 -->
                <el-table-column prop="intentUserPhone" label="意向人联系电话" min-width="180" >
                    <template slot-scope="{ row }">
                        <span>{{ row.intentUserPhone }}</span>
                    </template>
                </el-table-column>

                <!-- 申请时间 -->
                <el-table-column prop="createTime" label="申请时间" min-width="180" >
                    <template slot-scope="{ row }">
                        <span>{{ row.createTime }}</span>
                    </template>
                </el-table-column>

                <!-- 状态 -->
                <el-table-column prop="status" label="状态" min-width="100" >
                    <template slot-scope="{ row }">
                        <span :class="['status-tag', getStatusClass(row.status)]">
                            {{ row.status | initDic(statusDic) }}
                        </span>
                    </template>
                </el-table-column>

                <!-- 操作 -->
                <el-table-column label="操作" width="100" fixed='right'>
                    <template slot-scope="{ row }">
                        <el-button type="text" @click="handleAudit(row)" v-if="row.status == 0">审核</el-button>
                        <el-button type="text" @click="handleDelete(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
		</el-card>

		<!-- 审核弹窗 -->
		<AuditDialog 
			:visible.sync="isAuditDialogVisible" 
			:initial-data="{
				auditResult: currentAuditRow.auditResult || 'pass',
				auditRemark: currentAuditRow.auditRemark || ''
			}"
			@submit="handleAuditSubmit"
		/>
	</div>
</template>

<script>
import util from "../../utils/util.js";
import AuditDialog from './components/audit-dialog.vue';

export default {
	name: 'DemandCooperationList',
	components: {
		AuditDialog
	},
	data() {
		return {
			util: util,
			tableData: [],
            demandId: '',
			pageParam: null,
			// 控制审核弹窗显示
			isAuditDialogVisible: false,
			// 当前审核行的数据
			currentAuditRow: {},
			// 状态选项
			statusDic: []
		};
	},
	mounted() {
        this.$getDic('IntentStatus','select').then(res=>{ this.statusDic = res; })
        // 获取路由参数中的 demandId
        this.demandId = this.$route.query.demandId;
        if (this.demandId) {
            this.getTableData();
        }
	},
	methods: {
        getTableData () {
            this.$Axios._post({
                url: this.$Config.apiUrl.supplyBackIntentionList,
                method: 'post',
                params: {
                    supplyDemandId: this.demandId,
                }
            }).then(({data}) => {
                this.tableData = data;
            }).catch(() => {
                
            });
        },
		// 获取状态样式类
		getStatusClass(status) {
			const classMap = {
				0: 'pending',
				1: 'success',
				2: 'danger',
				3: 'warning'
			};
			return classMap[status] || '';
		},

		// 审核操作
		handleAudit(row) {
			this.currentAuditRow = row;
			this.isAuditDialogVisible = true;
		},

		// 删除操作
		handleDelete(row) {
			this.$confirm('确定要删除该合作意向吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$Axios._post({
					url: this.$Config.apiUrl.supplyBackIntentionDelete,
					method: 'post',
					params: {
						id: row.id
					}
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					// 刷新列表
					this.getTableData();
				}).catch(() => {
					this.$message({
						type: 'error',
						message: '删除失败!'
					});
				});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},

		// 处理审核提交
		handleAuditSubmit(data) {
			this.$Axios._post({
				url: this.$Config.apiUrl.supplyBackIntentionAudit,
				method: 'post',
				params: {
					id: this.currentAuditRow.id,
					auditStatus: data.auditStatus,
					auditRemark: data.auditRemark
				}
			}).then(() => {
				this.$message.success('审核成功');
				// 刷新列表
				this.getTableData();
			}).catch(() => {
				this.$message.error('审核失败');
			});
		},
        // 获取图片数量
        getImageCount(imageUrls) {
            if (!imageUrls) return 0;
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images.length : 0;
            } catch (e) {
                return 0;
            }
        },

        // 获取图片列表
        getImageList(imageUrls) {
            if (!imageUrls) return [];
            try {
                const images = JSON.parse(imageUrls);
                return Array.isArray(images) ? images : [];
            } catch (e) {
                return [];
            }
        },
	}
};
</script>

<style scoped lang="scss">
.image-attachment {
	
	cursor: pointer;
}

.image-count {
	font-size: 12px;
	color: #999;
	margin-top: 4px;
    white-space: nowrap;
}

.status-tag {
	padding: 2px 8px;
	border-radius: 4px;
	font-size: 12px;
}

.status-tag.pending {
	background-color: #f5f5f5;
	color: #999;
}

.status-tag.success {
	background-color: #e6f7ee;
	color: #52c41a;
}

.status-tag.danger {
	background-color: #fff1f0;
	color: #f5222d;
}

.status-tag.warning {
	background-color: #fff7e6;
	color: #fa8c16;
}

.el-button--mini {
	padding: 4px 8px;
	font-size: 12px;
}

/* 操作按钮间距 */
.el-button + .el-button {
	margin-left: 8px;
}
</style>